// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import { v4 as uuid } from 'uuid';

import type { AIDefinitionsAction } from './actions';
import { AIDefinitionsActionType } from './actions';
import type { AIDefinitionsPluginState } from './types';

const reducer = (
	state: AIDefinitionsPluginState,
	action: AIDefinitionsAction,
): AIDefinitionsPluginState => {
	switch (action.type) {
		case AIDefinitionsActionType.UPDATE_STATE:
			return {
				...state,
				// action is partial state, so we default to current state if not provided
				enabled: action.enabled ?? state.enabled,
				autoHighlightEnabled: action.autoHighlightEnabled ?? state.autoHighlightEnabled,
				enablementSource: action.enablementSource ?? state.enablementSource,
			};

		case AIDefinitionsActionType.UPDATE_KEYWORD_REGEX:
			return {
				...state,
				keywordRegex: action.keywordRegex,
			};

		case AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS_SESSION_ID:
			return {
				...state,
				// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
				keywordDecorationsSessionId: uuid(),
			};

		case AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS:
			return {
				...state,
				keywordDecorations: action.keywordDecorations,
			};

		case AIDefinitionsActionType.OPEN_READING_AIDS_POPUP:
			return {
				...state,
				currentKeywordId: action.keywordId,
				isReadingAidsPopupOpen: true,
				// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
				readingAidsPopupKey: uuid(),
				readingAidsPopupProps: action.readingAidsPopupProps,
				isReadingAidsPopupLoading: true,
			};

		case AIDefinitionsActionType.CLOSE_READING_AIDS_POPUP:
			return {
				...state,
				currentKeywordId: undefined,
				isReadingAidsPopupOpen: false,
				readingAidsPopupKey: undefined,
				readingAidsPopupProps: undefined,
			};

		case AIDefinitionsActionType.READING_AIDS_POPUP_LOADED:
			return {
				...state,
				isReadingAidsPopupLoading: false,
			};

		default:
			return state;
	}
};

export default reducer;
